const formDataSchema ={
    feilds: [
        //  {
        //     id: 1,
        //     name: 'consultant_name',
        //     text: 'Consultant Name',
        //     visible: true,
        //     element: 'select2',
        //     required: true,
        //     input_type: 'select',
        //     placeholder: 'Consultant Name',
        //     icon: 'user',
        //     rules: [
        //         // {
        //         //     test: (value) => {
        //         //         return (value !== null && value.length > 0);
        //         //         return true;
        //         //     },
        //         //     message: 'Consultant Name'
        //         // }
        //     ],
        //     errors: [],
        //     value: null,
        //     valid: false,
        //     state: '',
        //     disable: false,
        //     className: 'col-4'
        // }, {
        //     id: 2,
        //     name: 'payer_type',
        //     text: 'Payer Type',
        //     visible: true,
        //     element: 'select2',
        //     required: true,
        //     input_type: 'select',
        //     placeholder: 'Payer Type',
        //     icon: 'user',
        //     rules: [
        //         {
        //             test: (value) => {
        //                 return (value !== null && value.length > 0);
        //                 return true;
        //             },
        //             message: 'Gender'
        //         }
        //     ],
        //     errors: [],
        //     value: null,
        //     valid: false,
        //     state: '',
        //     disable: false,
        //     className: 'col-4'
        // }, 
        {
            id: 3,
            name: 'date',
            text: 'Date',
            visible: true,
            element: 'daterange',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select From and To Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 d-flex pr-0'
        }
    ]
}

const reportTable={
    tableList: [
        {
            'id': 1,
            'text': 'S.No',
            'name':'#',
            'visible': true,
            'className': null
        },{
            'id': 2,
            'text': 'Patient Name',
            'name':'patient_name',
            'visible': true,
            'className': null
        },{
            'id': 3,
            'text': 'Patient IP Number',
            'name':'patient_ip_number',
            'visible': true,
            'className': null
        },{
            'id': 4,
            'text': 'Discharge Date',
            'name':'discharge_date',
            'visible': true,
            'className': null
        },{
            'id': 5,
            'text': 'Payer Type',
            'name':'payer_type',
            'visible': true,
            'className': null
        },{
            'id': 6,
            'text': 'Doctor Name',
            'name':'doctor_name',
            'visible': true,
            'className': null
        },
        
        // {
        //     'id': 7,
        //     'text': 'Initial Counselled Amount (a)',
        //     'name':'initial_couselled_amt',
        //     'visible': true,
        //     'className': null
        // },
        
        {
            'id': 8,
            'text': 'Final Counselled Amount (b)',
            'name':'final_recounselled_amt',
            'visible': true,
            'className': null
        },{
            'id': 9,
            'text': 'Final Bill',
            'name':'final_bill',
            'visible': true,
            'className': null
        },{
            'id': 10,
            'text': 'variance',
            'name':'variance',
            'visible': true,
            'className': null
        },{
            'id': 11,
            'text': 'variance %',
            'name':'variance_percent',
            'visible': true,
            'className': null
        },{
            'id': 12,
            'text': 'Positive Variance',
            'name':'positive_variance',
            'visible': true,
            'className': null
        },{
            'id': 13,
            'text': 'Negative variance',
            'name':'negative_variance',
            'visible': true,
            'className': null
        },
    ]
}

export default formDataSchema;